import React, { useState, useEffect } from 'react';
import './BrandsModelsManager.css';

const ModalCadastroModelo = ({
  isOpen,
  onClose,
  onSave,
  marcas,
  setSelectedBrand,
  selectedBrand
}) => {
  const [modelo, setModelo] = useState('');
  const [marcaId, setMarcaId] = useState('');

  useEffect(() => {
    if (isOpen && selectedBrand) {
      setMarcaId(selectedBrand.id);
    }
  }, [isOpen, selectedBrand]);

  const handleSubmit = () => {
    if (!modelo.trim() || !marcaId) return;

    onSave({ modelo: modelo.trim(), marcaId });
    setModelo('');
    setMarcaId('');
    onClose();
  };

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    setMarcaId(selectedId);

    // Encontra a marca pelo ID e atualiza o selectedBrand no componente pai
    const marcaSelecionada = marcas.find((m) => m.id === selectedId);
    if (marcaSelecionada) {
      setSelectedBrand(marcaSelecionada);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="bm-modal-overlay">

      <div className="bm-modal">

        <div className="bm-modal-header">
          <h2>Novo Modelo</h2>
          <p>Cadastre um novo modelo vinculado a uma marca</p>
        </div>

        <div className="bm-form">

          <select
            value={marcaId}
            onChange={handleSelectChange}
          >
            <option value="">
              Selecione a marca
            </option>

            {marcas.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>

          <input
            type="text"
            placeholder="Nome do Modelo"
            value={modelo}
            onChange={(e) => setModelo(e.target.value)}
          />

        </div>

        <div className="bm-modal-actions">

          <button
            className="bm-cancel-btn"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            className="bm-save-btn"
            onClick={handleSubmit}
          >
            Salvar
          </button>

        </div>

      </div>
    </div>
  );
};

export default ModalCadastroModelo;